// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ButtonCross_wrapper__Aepli","close":"ButtonCross_close__25WWn"};